import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import loading from  '@/components/loading.vue'
// import VConsole from 'vconsole';
// const vConsole = new VConsole();
Vue.component('loading', loading); //全局注册loading组件
import 'vant/lib/index.css'; //vant样式
import './pemissions' //路由守卫
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp'] //微信开放标签
import Vant from 'vant';  //导入vant
Vue.use(Vant);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
